import { connect } from 'react-redux'

import { doSelectAllTickets, doToggleSearchPinned } from 'actions/app'

import {
  selectAccountCanSeePinnedSearches,
  selectCurrentTicketListType,
  selectShowExperimentalLabelUi,
} from 'selectors/app'
import {
  selectTicketListTitle,
  selectIsTicketSelectionMode,
} from 'selectors/ticket_list'
import {
  selectCurrentSearchIsFolderSearch,
  selectIsFreeFormSearch,
} from 'selectors/search'
import {
  selectIsCurrentTicketSearchPinnable,
  selectCurrentTicketSearchQueryId,
} from 'selectors/search/base'
import { selectCurrentSearchPin } from 'selectors/pinned_searches'
import {
  doDeleteSelectedTickets,
  doMarkSelectedTicketsAsSpam,
  doMarkSelectedTicketsAsUnread,
  doUnmarkBulkSelectionMode,
} from 'actions/tickets'
import { doOpenChangeInboxMenu } from 'actions/menus'

import TitleBarView from 'components/ConversationList/Header/TitleBar'
import Count from './Count'
import SortMenu from './SortMenu'
import BulkActionBar from './BulkActionBar'

const select = state => ({
  canSeePinnedSearches: selectAccountCanSeePinnedSearches(state),
  isFreeFormSearch: selectIsFreeFormSearch(state),
  isSearchPinnable: selectIsCurrentTicketSearchPinnable(state),
  isSelectionMode: selectIsTicketSelectionMode(state),
  pinnedSearch: selectCurrentSearchPin(state),
  searchIsFolderSearch: selectCurrentSearchIsFolderSearch(state),
  title: selectTicketListTitle(state),
  queryId: selectCurrentTicketSearchQueryId(state),
  titleType: selectCurrentTicketListType(state),
  isExperimentalLabelUiEnabled: selectShowExperimentalLabelUi(state),
  CountComponent: Count,
  SortMenuComponent: SortMenu,
  BulkActionBarComponent: BulkActionBar,
})

const perform = {
  onPinUnpinClick: doToggleSearchPinned,
  onSelectAllClick: doSelectAllTickets,
  onUnselectAllClick: doUnmarkBulkSelectionMode,
  onDeleteClick: doDeleteSelectedTickets,
  onMarkAsSpamClick: doMarkSelectedTicketsAsSpam,
  onMarkAsUnreadClick: doMarkSelectedTicketsAsUnread,
  onChangeMailboxClick: doOpenChangeInboxMenu,
}

export default connect(select, perform)(TitleBarView)
